<template>
  <div>
    <div class="app-title">
      <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
    </div>
    <section class="app-content">
      <div id="entity-viewer" class="content">
        <div class="card">
          <div id="collapseOne" aria-labelledby="headingOne" class="collapse show"
               data-parent="#accordionFilter">
            <div class="card-body">
              <em-workflow-business-data-editor :business-data="$_emWorkflowTaskMixin_businessData"
                                                :entity="modelName">
              </em-workflow-business-data-editor>
            </div>
          </div>
        </div>
      </div>
      <div id="workflow-process_execution" class="content">
        <em-workflow-process-execution :approved-labels="approvedLabels"
                                       :businessKey="$_emWorkflowTaskMixin_businessKey"
                                       :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
        >
        </em-workflow-process-execution>
      </div>

      <div v-if="$_emWorkflowTaskMixin_isShowTaskComplete" id="em-workflow-task-complete" class="content">
        <em-workflow-task-complete :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                   :taskId="$_emWorkflowTaskMixin_taskId"
                                   approveLabel="处理完成" attachmentDisable
                                   commentDisable rejectClass="btn btn-primary btn-sm"
                                   @taskCompleted="$_emWorkflowTaskMixin_handleTaskCompleted">
          <!--自定义插槽示例,异常转维修工单-->
          <template slot="customSlot" slot-scope="slotScopeToRepairWorkOrder">
            <em-button v-menu-permission="'edit'"
                       customLabel="title.em.epi.todo.abnormal.toAbnormal"
                       showName
                       type="add"
                       v-bind:class="'btn btn-primary'"
                       @click="handleToRepairWorkOrder">
            </em-button>
          </template>
        </em-workflow-task-complete>
      </div>
    </section>
  </div>
</template>
<script>
// Author YuJiaBei
// Date 2020-07-24 14:09:42

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";

export default {
  name: "inspectionRecordWorkflowTaskView",
  mixins: [emWorkflowTaskMixin],
  data() {
    return {
      repairWorkOrderData: {rwoCodeBda: '', rwoIdOrigin: '', rwoCodeRor: '', rwoJobContent: '', rwoRemark: ''},
      approvedLabels: {
        1: '通过',
        0: '拒绝',
        2: '转工单'
      }
    }
  },
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    }
  },
  methods: {
    handleToRepairWorkOrder() {
      // this.repairWorkOrderData.emArchBasicDataCode = this.$_emWorkflowTaskMixin_businessData.emArchBasicDataCode
      // this.repairWorkOrderData.originId = this.$_emWorkflowTaskMixin_businessData.id
      this.repairWorkOrderData.rwoCodeBda = this.$_emWorkflowTaskMixin_businessData.emArchBasicDataCode
      this.repairWorkOrderData.rwoIdOrigin = this.$_emWorkflowTaskMixin_businessData.id
      this.repairWorkOrderData.rwoCodeRor = this.$_emWorkflowTaskMixin_processDefinitionKey
      this.repairWorkOrderData.rwoJobContent = this.$_emWorkflowTaskMixin_businessData.inspectionScheduleDetailName
      this.repairWorkOrderData.rwoRemark = this.$_emWorkflowTaskMixin_businessData.abnormalDescription

      this.$store.commit("repairWorkOrder/setNewEntity", {});
      //附加异常台账数据
      this.$store.commit("repairWorkOrder/appendAbnormalDataForEntity", this.repairWorkOrderData)
      this.$store.commit("repairWorkOrder/setCrudState", 'new');

      //设置回调url
      this.$store.commit("repairWorkOrder/setEditReturnUrl", "/em/inspection/inspectionRecordList")
      this.$store.commit("repairWorkOrder/setEditReturnPathType", "todo")

      //pathType决定了面包屑的显示
      this.$router.push({name: 'repairWorkOrderEdit', query: {pathType: "fromAbnormal"}});
    }
  }
};
</script>
